import { useState, useEffect } from "react";
import { ReactTransliterate } from "react-transliterate";
import editIcon from "../../assests/icons/edit.jpg";
import deleteIcon from "../../assests/icons/delete.jpg";
import publishIcon from "../../assests/icons/publish.png";
import { isAdmin, isApprover, isPublisher } from "../utils/auth.js";
import { showHideLoader, processImage } from "../utils/helper.js";
import {
  wedgitsObject,
  save,
  update,
  getPreview,
  getLive,
  deleteLive,
  deletePreview,
  publish,
} from "../../network/lib/wedgits.js";
import parse from "html-react-parser";
import {
  getContentTypes,
  getDirections,
  getRequiredTypes,
  getWedgitsNames,
} from "../../network/lib/masterData.js";

function Wedgits({ user }) {
  const [wedgitsNamesTypes, setWedgitsNamesTypes] = useState();
  const [requiredTypes, setRequiredTypes] = useState();
  const [contentTypes, setContentTypes] = useState();
  const [directions, setDirections] = useState();
  const [wedgitsNamesType, setWedgitsNamesType] = useState("1");
  const [isRequiredType, setIsRequiredType] = useState("2");
  const [textType, setTextType] = useState("1");
  const [wedgitsContent, setWedgitsContent] = useState("");
  const [isMarqueeRequiredType, setIsMarqueeRequiredType] = useState("2");
  const [marqueeDirection, setMarqueeDirection] = useState("1");
  const [isImageRequiredType, setIsImageRequiredType] = useState("2");
  const [image, setImage] = useState("");
  const [previewData, setPreviewData] = useState();
  const [liveData, setLiveData] = useState();

  const [id, setId] = useState(0);

  const admin = isAdmin(user.roleId);
  const approver = isApprover(user.roleId);
  const publisher = isPublisher(user.roleId);

  useEffect(() => {
    !wedgitsNamesTypes && populateWedgitsNamesTypes();
    !requiredTypes && populateRequiredTypes();
    !contentTypes && populateContentTypes();
    !directions && populateDirections();
  }, []);

  const populateWedgitsNamesTypes = () => {
    getWedgitsNames().then((res) => {
      if (res.status == 200) {
        setWedgitsNamesTypes(res.data);
      }
    });
  };

  const populateRequiredTypes = () => {
    getRequiredTypes().then((res) => {
      if (res.status == 200) {
        setRequiredTypes(res.data);
      }
    });
  };

  const populateContentTypes = () => {
    getContentTypes().then((res) => {
      if (res.status == 200) {
        setContentTypes(res.data);
      }
    });
  };

  const populateDirections = () => {
    getDirections().then((res) => {
      if (res.status == 200) {
        setDirections(res.data);
      }
    });
  };

  const setToDefault = () => {
    setWedgitsNamesType("1");
    setIsRequiredType("2");
    setTextType("1");
    setWedgitsContent("");
    setIsMarqueeRequiredType("2");
    setMarqueeDirection("1");
    setIsImageRequiredType("2");
    setImage("");
    setId(0);
    setPreviewData(undefined);
    setLiveData(undefined);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    resetMessage();
    setToDefault();
  };

  const resetMessage = () => {
    let message = document.getElementById("message");
    message.innerHTML = "";
    message.classList.replace("success", "alert");
    return message;
  };

  const handleEdit = (e) => {
    e.preventDefault();
    resetMessage();

    let dataParams = e.target.getAttribute("data-params");
    if (dataParams) {
      let params = JSON.parse(dataParams);
      setId(params.id);
      setWedgitsNamesType(params.nameId);
      setIsRequiredType(params.isVisibileId);
      setTextType(params.contentTypeId);
      setWedgitsContent(params.content);
      setIsMarqueeRequiredType(params.isMarqueeRequiredId);
      if (params.isMarqueeRequiredId == "1") {
        setMarqueeDirection(wedgitsObject.marqueeDirectionId);
      }
      if (params.image) {
        setIsImageRequiredType("1");
        setImage(params.image);
      } else {
        setIsImageRequiredType("2");
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let message = resetMessage();

    setLiveData(undefined);
    setPreviewData(undefined);

    if (wedgitsContent == "") {
      message.innerHTML = "Please provide Wedgits Content";
    } else {
      showHideLoader(true);

      wedgitsObject.id = id;
      wedgitsObject.nameId = wedgitsNamesType;
      wedgitsObject.isVisibileId = parseInt(isRequiredType);
      wedgitsObject.contentTypeId = textType;
      wedgitsObject.content = wedgitsContent;
      wedgitsObject.isMarqueeRequiredId = parseInt(isMarqueeRequiredType);
      wedgitsObject.marqueeDirectionId =
        isMarqueeRequiredType == "1" ? parseInt(marqueeDirection) : 0;
      wedgitsObject.image = isImageRequiredType == "1" && image ? image : "";
      wedgitsObject.userName = user.userName;

      if (id == 0) {
        save(wedgitsObject).then((res) => {
          if (res.status == 200 && res.data) {
            message.classList.replace("alert", "success");
            message.innerHTML = "Data saved successfully!!!";
            setToDefault();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
          showHideLoader();
        });
      } else {
        update(wedgitsObject).then((res) => {
          if (res.status == 200 && res.data) {
            message.classList.replace("alert", "success");
            message.innerHTML = "Data updated successfully!!!";
            setToDefault();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
          showHideLoader();
        });
      }
    }
  };

  const fetchPreviewData = () => {
    showHideLoader(true);

    getPreview()
      .then((resp) => {
        if (resp.status == 200) {
          setPreviewData(resp.data);
          setLiveData(undefined);
          showHideLoader();
        }
      })
      .catch((e) => console.log(e));
  };

  const handlePreviewData = (e) => {
    e.preventDefault();
    resetMessage();
    fetchPreviewData();
  };

  const fetchLiveData = () => {
    showHideLoader(true);

    getLive()
      .then((resp) => {
        if (resp.status == 200) {
          setLiveData(resp.data);
          setPreviewData(undefined);
          showHideLoader();
        }
      })
      .catch((e) => console.log(e));
  };

  const handleLiveData = (e) => {
    e.preventDefault();
    resetMessage();
    fetchLiveData();
  };

  const handleDeletePreview = (e) => {
    e.preventDefault();
    let message = resetMessage();

    if (window.confirm("Do you really want to delete the item from Preview?")) {
      let params = e.target.getAttribute("data-params");
      if (params) {
        wedgitsObject.id = parseInt(params);
        wedgitsObject.userName = user.userName;
        deletePreview(wedgitsObject).then((res) => {
          if (res.status == 200 && res.data) {
            fetchPreviewData();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
        });
      }
    }
  };

  const handleDeleteLive = (e) => {
    e.preventDefault();
    let message = resetMessage();
    if (
      window.confirm(
        "Do you really want to delete the item from Live? This will be moved to Preview."
      )
    ) {
      let params = e.target.getAttribute("data-params");
      if (params) {
        wedgitsObject.id = parseInt(params);
        wedgitsObject.userName = user.userName;
        deleteLive(wedgitsObject).then((res) => {
          if (res.status == 200 && res.data) {
            fetchLiveData();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
        });
      }
    }
  };

  const handlePublish = (e) => {
    e.preventDefault();
    let message = resetMessage();

    let params = e.target.getAttribute("data-params");
    if (params) {
      wedgitsObject.id = parseInt(params);
      wedgitsObject.userName = user.userName;
      publish(wedgitsObject).then((res) => {
        if (res.status == 200 && res.data) {
          fetchPreviewData();
          setToDefault();
        } else {
          message.innerHTML = "Some error occurred. Please try again";
        }
      });
    }
  };

  const handleImage = (e) => {
    processImage(e.target.files[0], resetMessage(), setImage);
  };

  const contents = (
    <>
      <table>
        <tbody>
          <tr>
            <th align="center" colSpan="4">
              Wedgits Details
            </th>
          </tr>
          <tr>
            <td align="right">
              <span>Name</span>
            </td>
            <td colSpan={3}>
              {wedgitsNamesTypes && (
                <select
                  onChange={(e) => setWedgitsNamesType(e.target.value)}
                  value={wedgitsNamesType}
                  style={{ width: "322px" }}
                >
                  {wedgitsNamesTypes.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Is Wedgits Required</span>
            </td>
            <td colSpan={3}>
              {requiredTypes && (
                <select
                  onChange={(e) => setIsRequiredType(e.target.value)}
                  value={isRequiredType}
                  style={{ width: "322px" }}
                >
                  {requiredTypes.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Text Type</span>
            </td>
            <td colSpan={3}>
              {contentTypes && (
                <select
                  onChange={(e) => setTextType(e.target.value)}
                  value={textType}
                  style={{ width: "322px" }}
                >
                  {contentTypes.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Content</span>
            </td>
            <td colSpan={3}>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="10" cols="97" />
                )}
                value={wedgitsContent}
                onChangeText={(text) => {
                  setWedgitsContent(text);
                }}
                lang="mr"
              />
            </td>
          </tr>
          <tr>
            <td></td>
            <td colSpan="3">
              <span>
                Note :- Add Pipe(|) Seperator In Between Every New Point On The
                List Option.
              </span>
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Is Marquee Required</span>
            </td>
            <td colSpan={3}>
              {requiredTypes && (
                <select
                  onChange={(e) => setIsMarqueeRequiredType(e.target.value)}
                  value={isMarqueeRequiredType}
                  style={{ width: "322px" }}
                >
                  {requiredTypes.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          {isMarqueeRequiredType == "1" ? (
            <tr>
              <td align="right">
                <span>Marquee Direction</span>
              </td>
              <td colSpan={3}>
                {directions && (
                  <select
                    onChange={(e) => setMarqueeDirection(e.target.value)}
                    value={marqueeDirection}
                    style={{ width: "322px" }}
                  >
                    {directions.map((x, i) => (
                      <option key={i} value={x.id}>
                        {x.name}
                      </option>
                    ))}
                  </select>
                )}
              </td>
            </tr>
          ) : (
            <></>
          )}
          <tr>
            <td align="right">
              <span>Is Image Required</span>
            </td>
            <td colSpan={3}>
              {requiredTypes && (
                <select
                  onChange={(e) => setIsImageRequiredType(e.target.value)}
                  value={isImageRequiredType}
                  style={{ width: "322px" }}
                >
                  {requiredTypes.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          {isImageRequiredType == "1" ? (
            <tr>
              <td align="right">
                <span>Image</span>
              </td>
              <td>
                <label
                  htmlFor="file-upload"
                  className="custom-file-upload"
                  style={{ width: "307px", textAlign: "center" }}
                >
                  Browse
                </label>
                <input
                  type="file"
                  id="file-upload"
                  accept="image/*"
                  onChange={(e) => handleImage(e)}
                />
              </td>
              <td colSpan={2}>
                {image && (
                  <img
                    src={image}
                    style={{ width: "150px", height: "150px", float: "left" }}
                  />
                )}
              </td>
            </tr>
          ) : (
            <></>
          )}
          <tr>
            <td colSpan={2}></td>
            <td style={{ textAlign: "right" }}>
              <input
                className="btn"
                type="submit"
                value="Cancel"
                id="btnCancel"
                onClick={handleCancel}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="Submit"
                id="btnSubmit"
                onClick={handleSubmit}
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td colSpan="4" style={{ textAlign: "center" }}>
              <div
                id="message"
                className="alert"
                style={{ textAlign: "center" }}
              ></div>
            </td>
          </tr>
          <tr>
            <td></td>
            <td colSpan={2}>
              <input
                className="btn"
                type="submit"
                style={{ float: "left" }}
                value="View Preview"
                id="btnPreviewData"
                onClick={handlePreviewData}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="View Live"
                id="btnLiveData"
                onClick={handleLiveData}
              />
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
      {previewData && (
        <table className="alternate-row">
          <thead>
            <tr align="center">
              <th align="center" colSpan={admin ? 10 : approver ? 9 : 8}>
                Preview
              </th>
            </tr>
            <tr>
              <td colSpan={admin ? 10 : approver ? 9 : 8}></td>
            </tr>
          </thead>
          <tbody>
            <tr align="center">
              {publisher && (
                <td style={{ textAlign: "center" }}>
                  <u>Publish</u>
                </td>
              )}
              <td>
                <u>Name</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Content Type</u>
              </td>
              <td>
                <u>Content</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Visibility</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Is Marquee Required</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Marquee Type</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Image</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Edit</u>
              </td>
              {admin && (
                <td style={{ textAlign: "center" }}>
                  <u>Delete</u>
                </td>
              )}
            </tr>
            {previewData.length > 0 ? (
              previewData.map((x, i) => (
                <tr key={i + 1} align="center">
                  {publisher && (
                    <td style={{ textAlign: "center" }}>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handlePublish}
                        src={publishIcon}
                        alt="Publish"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                  <td>{x.name}</td>
                  <td style={{ textAlign: "center" }}>{x.contentType}</td>
                  <td>{x.content}</td>
                  <td style={{ textAlign: "center" }}>{x.isVisibile}</td>
                  <td style={{ textAlign: "center" }}>{x.isMarqueeRequired}</td>
                  <td style={{ textAlign: "center" }}>{x.marqueeDirection}</td>
                  <td style={{ textAlign: "center" }}>
                    {x.image &&
                      parse(`<img src=${x.image}  style="width: 60px"/>`)}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <img
                      className="handle"
                      data-params={JSON.stringify(x)}
                      onClick={handleEdit}
                      src={editIcon}
                      alt="Edit"
                      border="0px"
                      style={{ width: "20px", height: "20px" }}
                    />
                  </td>
                  {admin && (
                    <td style={{ textAlign: "center" }}>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handleDeletePreview}
                        src={deleteIcon}
                        alt="Delete"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={admin ? 10 : approver ? 9 : 8}
                  style={{ textAlign: "center" }}
                >
                  No Data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      {liveData && (
        <table className="alternate-row">
          <thead>
            <tr align="center">
              <th align="center" colSpan={admin ? 8 : 7}>
                Live
              </th>
            </tr>
            <tr>
              <td colSpan={admin ? 10 : approver ? 9 : 8}></td>
            </tr>
          </thead>
          <tbody>
            <tr align="center">
              <td>
                <u>Name</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Content Type</u>
              </td>
              <td>
                <u>Content</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Visibility</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Is Marquee Required</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Marquee Type</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Image</u>
              </td>
              {admin && (
                <td style={{ textAlign: "center" }}>
                  <u>Delete</u>
                </td>
              )}
            </tr>
            {liveData.length > 0 ? (
              liveData.map((x, i) => (
                <tr key={i + 1} align="center">
                  <td>{x.name}</td>
                  <td style={{ textAlign: "center" }}>{x.contentType}</td>
                  <td>{x.content}</td>
                  <td style={{ textAlign: "center" }}>{x.isVisibile}</td>
                  <td style={{ textAlign: "center" }}>{x.isMarqueeRequired}</td>
                  <td style={{ textAlign: "center" }}>{x.marqueeDirection}</td>
                  <td style={{ textAlign: "center" }}>
                    {x.image &&
                      parse(`<img src=${x.image}  style="width: 60px"/>`)}
                  </td>
                  {admin && (
                    <td style={{ textAlign: "center" }}>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handleDeleteLive}
                        src={deleteIcon}
                        alt="Delete"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={admin ? 8 : 7} style={{ textAlign: "center" }}>
                  No Data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </>
  );

  return contents;
}

export default Wedgits;
